<form [formGroup]="formGroup">
    <div class="input-component"
        [ngClass]="{'pristine': (pristine$ | async), 'valid': (validStatus$ | async), 'invalid': (invalidStatus$ | async), 'disabled': (disabled$ | async)}">
        <div class="input-wrapper no-border">
            <div class="input-combobox-label">
                <label *ngIf="label" [attr.for]="fieldId">{{label}}</label>
            </div>
            <div class="input-combobox-select">
                <ng-select
                    class="aa-ng-select input-field"
                    [ngClass]="{'invalid': (invalidStatus$ | async)}" [id]="fieldId"
                    [items]="items | async"
                    bindLabel="label"
                    bindValue="value"
                    [clearable]="true"
                    (change)="onSelected()"
                    formControlName="formControlName"
                >
                </ng-select>
            </div>
        </div>
    </div>
</form>
